import { render, staticRenderFns } from "./training-property-display.vue?vue&type=template&id=4d214405&"
import script from "./training-property-display.vue?vue&type=script&lang=js&"
export * from "./training-property-display.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports